import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-button-label',
  templateUrl: './button-label.component.html',
  styleUrl: './button-label.component.scss'
})
export class ButtonLabelComponent {
  @Input() labelKey!: ButtonLabelKey;
}

export type ButtonLabelKey = "NEXT" | "SAVE";
